import { useState } from 'react';
import Slider from 'rc-slider';
import theme from 'config/theme';
import { ENV_CONFIG } from 'config/environment';
import { Row } from 'components/Row';
import { getSetLogoUrl, getSetVideoUrl } from 'helpers/imageUrls';
import Button from 'components/Button';
import Spacing from 'components/Spacing';
import { formatTime } from 'helpers/date';
import { useAppSelector } from 'helpers/hooks';
import {
  formatNumber,
  abbreviateNum,
  getUrlParams,
  getPathWithRef,
  sanitizeHtml,
} from 'helpers/utils';
import { getSetsData } from 'selectors/sets';
import { OrbsBackground } from './OrbsBackground';

export const OrbsHeader = () => {
  const setsData = useAppSelector(getSetsData);
  const { urlPartner } = getUrlParams();
  const [logoLoadFailed, setLogoLoadFailed] = useState(false);
  const [videoLoadFailed, setVideoLoadFailed] = useState(false);

  const sliderStyles = {
    rail: {
      height: 20,
      borderRadius: 20,
    },
    track: {
      background: setsData.set_misc?.primary_color || theme.colors.inkBlue,
      height: 20,
      borderRadius: 20,
    },
    handle: {
      display: 'none',
    },
  };

  return (
    <>
      <div
        className="orbs-container"
        style={
          !setsData?.set_misc?.has_header_video || videoLoadFailed
            ? { backgroundColor: setsData?.set_misc?.header_bg_color || theme.colors.oathBlue }
            : undefined
        }
      >
        {setsData?.set_misc?.has_header_video && !videoLoadFailed && (
          <OrbsBackground
            src={getSetVideoUrl(setsData, urlPartner)}
            setVideoLoadFailed={setVideoLoadFailed}
          />
        )}
        <div className="orbs-texts-container">
          {setsData.set_misc?.has_header_logo &&
            (!setsData.set_misc?.has_header_video || videoLoadFailed) &&
            !logoLoadFailed && (
              <img
                src={getSetLogoUrl(setsData, urlPartner)}
                alt="Set Logo"
                className="orbs-set-logo"
                onError={() => setLogoLoadFailed(true)}
              />
            )}
          <span className="orbs-title h1-dtm" style={{ color: setsData.set_misc?.secondary_color }}>
            {setsData.set_title}
          </span>
          <span
            className="orbs-description h4-text"
            style={{ color: setsData.set_misc?.secondary_color }}
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(setsData.set_desc) }}
          />
        </div>
        {setsData?.display_fundraising_bar &&
          setsData.fundraising_goal &&
          setsData.fundraising_goal !== '0' && (
            <>
              <Row $justifyContent="space-between" $alignItems="flex-end">
                <span
                  className="orbs-title h1-dtm slider"
                  style={{ color: setsData.set_misc?.secondary_color }}
                >
                  ${formatNumber(parseInt(setsData.fundraising_raised))}
                  <span
                    className="orbs-description h4-text slider"
                    style={{ color: setsData.set_misc?.secondary_color }}
                  >
                    {' '}
                    of ${formatNumber(parseInt(setsData.fundraising_goal))}{' '}
                    {setsData.set_misc?.goal_alt || 'Goal'}
                  </span>
                </span>
                <span
                  className="orbs-description h4-text slider"
                  style={{ color: setsData.set_misc?.secondary_color }}
                >
                  {abbreviateNum(setsData.fundraising_donation_count)} donations
                </span>
              </Row>
              <Slider
                min={0}
                max={100}
                value={
                  (parseInt(setsData.fundraising_raised) * 100) /
                  parseInt(setsData.fundraising_goal)
                }
                styles={sliderStyles}
              />
              <Spacing $size={16} />
              <Row $justifyContent="space-between">
                <span
                  className="orbs-description h4-text slider"
                  style={{ color: setsData.set_misc?.secondary_color }}
                >
                  Updated at {formatTime(new Date())}
                </span>
                {setsData.latest_fundraising_location &&
                  !setsData.set_misc?.hide_recent_location && (
                    <span
                      className="orbs-description h4-text slider"
                      style={{ color: setsData.set_misc?.secondary_color }}
                    >
                      Just donated from {setsData.latest_fundraising_location}
                    </span>
                  )}
              </Row>
            </>
          )}
        <Spacing $size={16} />
        {setsData?.pages?.length > 0 && setsData?.set_misc?.show_header_button !== false && (
          <>
            <Button
              text={
                setsData?.set_misc?.donate_custom_1 ||
                `DONATE TO ALL ${setsData?.pages?.length} ISSUES`
              }
              onPress={() =>
                window.open(
                  getPathWithRef(`${ENV_CONFIG().SITE_URL}/donate?p=${setsData.querystring}`),
                  '_blank'
                )
              }
              backgroundColor={setsData.set_misc?.secondary_color || theme.colors.white}
              textColor={setsData.set_misc?.primary_color || theme.colors.inkBlue}
              maxWidth={360}
            />
            <Spacing $size={8} />
            <span
              className="orbs-description h4-text slider"
              style={{ color: setsData.set_misc?.secondary_color }}
            >
              {setsData?.set_misc?.donate_custom_1_helper ||
                'Or donate to an issue of your choice below'}
            </span>
            <Spacing $size={60} />
          </>
        )}
      </div>
    </>
  );
};
